import React from 'react';
import { SectionCard, SectionTitle } from '../../Section.styles';
import { CommentItem, CommentMeta, CommentText } from './CommentsSection.styles';
import { formatDateTime } from '../../../../utils/dateFormatters';
import { ProductDetail } from 'src/types/ProductTypes';

interface CommentsSectionProps {
    comments: ProductDetail['comments'];
}

const CommentsSection: React.FC<CommentsSectionProps> = ({ comments }) => {
    if (!comments || comments.length === 0) {
        return null;
    }

    return (
        <SectionCard>
            <SectionTitle>Product Comments</SectionTitle>
            {comments.map((comment) => (
                <CommentItem key={comment.id}>
                    <CommentMeta>
                        <span>Category: {comment.category}</span>
                        <span>Updated: {formatDateTime(comment.lastUpdatedUtc)}</span>
                    </CommentMeta>
                    <CommentText>{comment.text}</CommentText>
                </CommentItem>
            ))}
        </SectionCard>
    );
};

export default CommentsSection;
